export const DARK_MODE_DEFAULT_ROLES = [
  'Primary_Reader',
  // 'IAM',
  // 'IQM',
  // 'IQS'
]
